export class GatewayUtil {
  static gatewayUrl = {
    10: 'https://beta.dashboard.sandbox.pagar.me/#/transactions/',
    11: 'https://beta.dashboard.pagar.me/#/transactions/',
    20: 'https://dashboard.belvo.com/production/payments/intents/',
    21: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_4owGvq6HgcwrNZyL/orders/',
    22: 'https://dash.pagar.me/merch_N1nrOnr5I4t5Oz5y/acc_KrqADEvI6asg4bJ0/orders/'
  };
}
